import React from "react";

const SternaSide = () => {
    return (
<div>
  {/* <div className=" bg-purple-800 p-5 text-amber-100 pt w-72">*/}  
  <div className="mt-52">
    </div>
    
    
</div>

    )
};

export default SternaSide;